app.service('deliveryPoints', function (orderConfig, modal, deliveryPointModal, deliveryPointLocation, deliveryPointAutocomplete, saveDeliveryData, geolocation, broker) {
	var config, url, autocompleteInput, savedParams = {};
	var $self, $list, $type, $form, $points, $lastPoint, $more, $lastPointBox;
	let selectedTypes = [];
	var isLoading = false; var loadLastUrl;
	let selectedAutocompletePlace = {};

	broker.on('BEFORE_PAGE_CHANGE', function() {
		selectedAutocompletePlace = {};
		isLoading = false;
		savedParams = {};
		selectedTypes = [];
	});

	function setElements() {
		$self = $('#delivery-points');
		$form = $('#choose-delivery-form');
		$list = $('.delivery-list', $self);
		$type = $('.js-parcel-type', $self);
		$lastPointBox = $('#last-saved-point', $self);
		autocompleteInput = $('.place-search', $self)[0];
	}
	function setEvents() {
		$self.on('click', '.js-delivery-point', function () {
			var $this = $(this);
			if ($points && $points.length) {
				if ($lastPoint && $lastPoint.length) {
					$lastPoint.removeClass('selected');
				}
				$points.removeClass('selected');
			}
			$this.addClass('selected');
			selectPoint({
				point: $this.data('point'),
				city: $this.data('city'),
				type: $this.data('type'),
				courier: $this.data('courier')
			});
		}).on('click', '.js-toggle-openings-hours', function (event) {
			$(this).closest('.js-delivery-point').toggleClass('show-opening-hours');
			event.preventDefault();
			event.stopPropagation();
		}).on('click', '.js-change-point', function (event) {
			var data = {
				longitude: $(this).data('longitude'),
				latitude: $(this).data('latitude')
			};
			$self.removeClass('show-last-selected');
			let $point = $(this).closest('js-delivery-point');
			$point.removeClass('saved').addClass('selected');
			load(data, { select: $point.data('point') });
			event.preventDefault();
			event.stopPropagation();
		}).on('click', '.js-more-delivery-points', function () {
			filter({ count: savedParams.count + 10 });
		}).on('click', '.js-parcel-type', function () {
			setSelectedParcelType($(this).data('type'));
			filter({ types: selectedTypes });
		}).on('click', '.js-show-map', function () {
			selectedAutocompletePlace.input = autocompleteInput.value;
			deliveryPointModal.open(selectedAutocompletePlace, function (params) {
				var $box = $('#last-saved-point');
				$box.html(params.html);
				$lastPoint = $box.find('.delivery-point');
				$lastPoint.addClass('visible selected saved');
				$self.removeClass('show-list show-more').addClass('show-last-selected has-last-selected');
				selectPoint({
					point: $lastPoint.data('point'),
					city: $lastPoint.data('city'),
					type: $lastPoint.data('type'),
					courier: $lastPoint.data('courier')
				});
			});
		}).on('click', '.js-delivery-points-search', function () {
			var $this = $(this);
			$self.addClass('search-geolocation');
			geolocation.findPosition(function (position) {
				$self.removeClass('search-geolocation');
				$this.attr({
					latitude: position.latitude,
					longitude: position.longitude
				});
				load({
					latitude: position.latitude,
					longitude: position.longitude
				});
			}, function (error) {
				$self.removeClass('search-geolocation');
			});
		}).on('click','.js-search-button', function() {
			const autocompleteInputValue = $(autocompleteInput).val();
			if(autocompleteInputValue != '') {
				deliveryPointLocation.findPlaceByAddress($(autocompleteInput).val(), function (location, partialMatch) {
					if (location && !partialMatch) {
						setSelectedAutocompletePoint(location);
					} else {
						showEmptyResults();
					}
				});
			}
		});
		setAutocomplete();
	}

	function setSelectedParcelType(type) {
		const $selectAll = $('.js-parcel-type[data-type=0]', $self);
		const idx = $.inArray(type, selectedTypes);
		if (type == '0') {
			selectedTypes = [];
		} else {
			if (idx == -1) {
				selectedTypes.push(type);
			} else {
				selectedTypes.splice(idx, 1);
			}
		}
		$type.removeClass('selected');
		if (!selectedTypes.length) {
			$selectAll.addClass('selected');
		} else {
			$selectAll.removeClass('selected');
			selectedTypes.forEach(function (t) {
				$type.filter('[data-type="' + t + '"]').addClass('selected');
			});
		}
	}

	function showEmptyResults() {
		$self.addClass('empty-location');
		$('.empty-location-message strong', $self).text($.trim(autocompleteInput.value))
	}

	function setAutocomplete() {
		deliveryPointAutocomplete.setAutocomplete(autocompleteInput, function (location) {
			if (location) {
				setSelectedAutocompletePoint(location);
			}
		}, function () {
			showEmptyResults();
		});
	}

	function setSelectedAutocompletePoint(location) {
		load({
			latitude: location.lat(),
			longitude: location.lng()
		});
	}


	function selectPoint(data) {
		$('#dhl-parcel-point-code-error, #post-office-code-error, #inpost-point-error').remove();
		if (config.deliveryType == 'inpost') {
			$('#inpost-point').val(data.point);
			$form.validate().element('#inpost-point');
		} else {
			if (data.courier == 'POST_OFFICE_POINT') {
				$('#dhl-parcel-point-code').val('').ignore(true);
				$('#post-office-code').val(data.point).ignore(false);
				$('#orlen-parcel-point-code').val('').ignore(true);
			} else if (data.courier == 'ORLEN_PARCEL_POINT') {
				$('#dhl-parcel-point-code').val('').ignore(true);
				$('#post-office-code').val('').ignore(true);
				$('#orlen-parcel-point-code').val(data.point).ignore(false);
			} else {
				$('#dhl-parcel-point-code').val(data.point).ignore(false);
				$('#post-office-code').val('').ignore(true);
				$('#orlen-parcel-point-code').val('').ignore(true);
			}
			$list.removeClass('validate-error');
			$form.validate().element('#dhl-parcel-point-code');
			$form.validate().element('#post-office-code');
		}
		if($('#home-delivery').length){
			var types = {
				INPOST: 'INPOST',
				POST_OFFICE_POINT: 'POCZTA_POLSKA_OFFICE',
				ORLEN_PARCEL_POINT: 'ORLEN_PARCEL',
				DHL_PARCEL_POINT: 'DHL_PARCEL'
			}
			saveDeliveryData.send({
				pickupPointType: types[data.courier],
				pickupPointCode: data.point,
				cityCode: data.city
			}, function(){
				config.parcelCode = data.point;
				config.cityCode = data.city;
				filter({ types: selectedTypes, count: 3 });
				$('#container').addClass('hide-points');
				$.scrollTo($('.row-delivery-point'));
				loadLast();
			});
		}
	}
	function selectLastSelected($el){
		$lastPoint = $el;
		if ($lastPoint && $lastPoint.length) {
			$('#delivery-point-localization').val('last');
			$('#delivery-point-localization-error').remove();
			$form.validate().element('#delivery-point-localization');
			$lastPoint.addClass('visible');
			$self.addClass('has-last-selected');
		}
		
	}
	function loadLast(url) {
		if(url){
			loadLastUrl = url;
		}
		if(loadLastUrl){
			$.ajax({
				url: loadLastUrl,
				data: {
					orderNumber: config.orderNumber
				},
				success: function (html) {
					$self.addClass('init');
					$('#last-saved-point').html(html);
					selectLastSelected($lastPointBox.find('.js-delivery-point'));
				},
				error: function () {
					$self.addClass('init');
					modal.alert('Błąd pobierania ostatnio wybranego punktu odbioru');
				}
			});
		}
	}

	function init() {
		config = orderConfig.getData();
		setElements();
		setEvents();
		if (config.deliveryType == 'inpost') {
			url = '/parcelMachines-list.ltr';
			loadLast('/order-last-selected-parcel-machine.ltr');
		} else {
			url = '/order-pickup-points.ltr';
			loadLast('/order-last-selected-pickup-point.ltr');
		}
		
	}
	function filter(params) {
		savedParams = $.extend(savedParams, params);
		console.log('filtrowanie', savedParams);
		$points.removeClass('visible');
		var $filtered = $points;
		if (savedParams.types && savedParams.types.length > 0) {						// wyfiltrowanie tylko punktów z konkretnego typu
			$filtered = $points.filter(function () {
				return savedParams.types.includes($(this).data('type'));
			});
		}
		$self.removeClass('empty-search empty-filter');
		if ($filtered.length == 0) {
			if (savedParams.types && savedParams.types.length != 0) {
				$self.addClass('empty-filter');
			} else {
				$self.addClass('empty-search');
			}
		}
		if ($filtered.length > savedParams.count) {
			$self.addClass('show-more');
		} else {
			$self.removeClass('show-more');
		}
		var $visible = $filtered.slice(0, savedParams.count);
		$($visible).addClass('visible');
	}

	function load(ajaxParams) {
		$self.addClass('loading-list').removeClass('empty-location');
		isLoading = true;
		$('#delivery-point-localization').val(ajaxParams);
		$('#delivery-point-localization-error').remove();
		$form.validate().element('#delivery-point-localization');
		if (ajaxParams.latitude && ajaxParams.longitude) {
			selectedAutocompletePlace.lat = ajaxParams.latitude;
			selectedAutocompletePlace.lng = ajaxParams.longitude;
		}
		$.ajax({
			url: url,
			data: ajaxParams,
			success: function (html) {
				$list.html(html);
				$list.addClass('list-load');
				$points = $('.js-delivery-point', $list);
				$more = $('.js-more-delivery-points', $list);
				$self.addClass('init show-list').removeClass('loading-list');
				if ($lastPoint && $lastPoint.length) {
					$lastPoint.removeClass('saved');
					$points.filter('[data-point="' + $lastPoint.data('point') + '"]').remove();
					$points = $('.js-delivery-point', $list);
				}
				setVisibleTypes();
				filter({ types: selectedTypes, count: 3 });
				isLoading = false;
				if($('.delivery-badge').length){
					let $b = $('.delivery-badge').detach();
					$b.appendTo( "#delivery-banner" );
				}else {
					$('#delivery-banner').remove();
				}
			},
			error: function () {
				$self.removeClass('loading-list');
				modal.alert('Błąd ładowania punktów odbioru. Spróbuj ponownie');
				isLoading = false;
			}
		});
	}
	function setVisibleTypes() {
		$type.not('[data-type="0"]').addClass('hidden');
		$points.each(function () {
			var type = $(this).data('type');
			$type.filter('[data-type="' + type + '"]').removeClass('hidden');
		});
		$type.filter('.selected.hidden').each(function () {
			setSelectedParcelType('0');
		});
	}
	function setZipCode(value) {
		var data = {};
		if (!isLoading && /\d{2}\-\d{3}/.test(value) && !($points && $points.length)) {
			if (config.deliveryType == 'inpost') {
				data.postcode = value;
			} else {
				data.zipCode = value;
			}
			load(data);
		}
	}
	function show(data){
		$self.removeClass('show-last-selected');
		if($lastPoint){
			$lastPoint.removeClass('saved').addClass('selected');
		}
		$.scrollTo($self,200);
		if($list.length && $list.hasClass('list-load')){
			// nic nie rób bo lista jest załadowana
		}else {
			load({
				longitude: data.longitude,
				latitude: data.latitude
			}, { select: data.point});
		}
	}

	return {
		init, setZipCode, show
	};
});